/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElTable as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInputNumber as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/input-number/style/css';
import { ElTableColumn as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("删除");
const _hoisted_2 = /*#__PURE__*/_createTextVNode("添加账号");
const _hoisted_3 = {
  class: "dialog-footer"
};
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消");
const _hoisted_5 = /*#__PURE__*/_createTextVNode("确认");
import { apiUsdkCreateTestAccount } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  props: {
    gameInfo: {
      type: Object
    }
  },
  emits: ['success'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const props = __props;
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const temp = {
      account: '',
      all_balance: 0
    };
    const tableData = ref([]);
    const handleAddItem = () => {
      let len = tableData.value.length;
      if (len) {
        let last = tableData.value[len - 1];
        if (!last.account) {
          ElMessage({
            type: 'warning',
            message: '请完成账号信息!'
          });
          return;
        }
      }
      tableData.value.push(JSON.parse(JSON.stringify(temp)));
    };
    const handleDelItem = index => {
      tableData.value.splice(index, 1);
    };
    const handleClose = () => {
      dialogVisible.value = false;
      tableData.value = [];
    };
    const handleConfirm = () => {
      const list = tableData.value.filter(item => item.account);
      if (!list.length) {
        ElMessage({
          type: 'warning',
          message: '请添加账号!'
        });
        return;
      }
      let params = {
        gid: props.gameInfo && props.gameInfo.Id,
        // sw: this.sw,
        list
      };
      confirmLoading.value = true;
      apiUsdkCreateTestAccount(params).then(res => {
        if (res.code === 0) {
          handleClose();
          emits('success');
        }
      }).finally(() => {
        confirmLoading.value = false;
      });
    };
    const openModal = () => {
      dialogVisible.value = true;
    };
    expose({
      openModal
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_table_column = __unplugin_components_1;
      const _component_el_input_number = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_table = __unplugin_components_4;
      const _component_el_dialog = __unplugin_components_5;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogVisible.value = $event),
        title: "添加账号",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: confirmLoading.value,
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_table, {
          ref: "tableRef",
          data: tableData.value,
          class: "marginT20"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            property: "goods",
            label: "用户名"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.account,
              "onUpdate:modelValue": $event => scope.row.account = $event,
              maxlength: "300"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            property: "name",
            label: "账号额度",
            width: "300"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input_number, {
              min: 0,
              modelValue: scope.row.all_balance,
              "onUpdate:modelValue": $event => scope.row.all_balance = $event
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            property: "password",
            label: "密码",
            width: "300"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.password,
              "onUpdate:modelValue": $event => scope.row.password = $event
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              size: "small",
              link: "",
              type: "danger",
              onClick: $event => handleDelItem(scope.$index)
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_button, {
          class: "mt-4 marginT10 width100",
          onClick: handleAddItem
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});